import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

// O leaflet.heat se pendura no L global (L.heatLayer)
window.L = L;
require('leaflet.heat');

export default L;
